import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

import { DeliveryConfirmLocation as RedesignDeliveryConfirmLocation } from '../../../pages';
import * as Actions from '../../actions/Actions';
import * as Api from '../../Api';
import * as Data from '../../Data';
import { flagService } from '../../services';
import * as Store from '../../Store';
import { default as LegacyCustomLocation } from './index.weborder';

const pageComponent = flagService.componentToggle(
  'uiRedesign',
  RedesignDeliveryConfirmLocation,
  LegacyCustomLocation,
);

export type StateProps = {
  addressSuggestion: { suggestion: string; postalCode: any };
  AppConfig: Data.Async<Api.AppConfig>;
  AppDesignScheme: Api.AppDesignScheme;
  Config: Data.Config;
  isDark: boolean;
  LocationGeo: Api.Geo;
  ToastMessages: string[];
  translate: any;
};

export type DispatchProps = {
  AddLocation: (location: Api.Geo, certainty: Store.LocationCertainty) => any;
  AddToast: (message: string) => any;
  LoadDeliveryLocations: () => any;
};

const mapStateToProps = (state: Store.State): StateProps => ({
  addressSuggestion: state.flipdish.addressSuggestion,
  AppConfig: state.flipdish.AppConfig,
  AppDesignScheme: state.appDesignScheme,
  Config: state.flipdish.Config,
  isDark: state.flipdish.isDark,
  LocationGeo: state.flipdish.Location.geo,
  ToastMessages: state.flipdish.ToastMessages,
  translate: getTranslate(state.locale),
});

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  AddLocation: (location: Api.Geo, certainty: Store.LocationCertainty) => {
    dispatch(Actions.AddLocation(location, certainty));
  },

  AddToast: (message: string) => {
    dispatch(Actions.AddToast(message));
  },

  LoadDeliveryLocations: () => {
    dispatch(Actions.LoadDeliveryLocations());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(pageComponent);
